import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { isPlainLeftClick } from '@app/shared/util';
import type { PlanningDialogData } from '../rental-dialogs.contract';
import { RentalLifecycleStore } from '../rental-lifecycle.store';
import { RentalPlanningComponent } from './rental-planning.component';

// Planning en dialogue depuis la F3 : son propre store, jamais le formulaire de la F3 qui perd les prescriptions (E.4).
@Component({
  selector: 'app-rental-planning-dialog',
  templateUrl: './rental-planning-dialog.component.html',
  styleUrls: ['./rental-planning-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, RouterLink, RentalPlanningComponent],
  providers: [RentalLifecycleStore],
})
export class RentalPlanningDialogComponent implements OnInit {
  readonly data: PlanningDialogData = inject(MAT_DIALOG_DATA);
  readonly dialogRef: MatDialogRef<RentalPlanningDialogComponent, void> = inject(MatDialogRef);
  protected readonly store = inject(RentalLifecycleStore);

  ngOnInit(): void {
    this.store.open(this.data.orderId);
  }

  onDecided(): void {
    this.data.onDecision?.();
  }

  // Un clic gauche simple navigue dans l'onglet : le dialogue se ferme ; Ctrl ou clic milieu ouvrent un onglet, il reste.
  onPageLink(e: MouseEvent): void {
    if (isPlainLeftClick(e)) this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
